import type { FaireProductEntity } from "../../entity_types/product";

export const p_r24dmcvs3r: FaireProductEntity = {
  token: "p_r24dmcvs3r",
  type: "product",
  name: "15 pc Mini gem towers for crystal grids G202",
  brandToken: "b_yrt8x5m6m6",
  brandName: "The 7 Directions",
  imageUrl:
    "https://cdn.faire.com/fastly/d0523f20b2fc6cc29fa769e3cc402d72311945c6c480be580c45b5791cd25dbb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/80f297b402b7c27922d991936f4874b2a4b802b56f16e9f34a0cea1039aa229a.jpeg",
    "https://cdn.faire.com/fastly/41233d6f3b01df8c2e8913f15dff95750e5aacb2790c33200cdb05089c83f4e0.jpeg",
  ],
  priceDollars: 10.39,
  description:
    '15 pc Mini gem towers for crystal grids G202\nApprox 1.3"\n\nPlease note that these are random picks , these pictures are reference of what you will receive.',
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:42.221Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
